
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/allergens",
      function () {
        return require("private-next-pages/allergens/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/allergens"])
      });
    }
  